import useObservableValue from "../../../hooks/useObservableValue";
import caseFilterState$, {
  caseFilterCount$,
  initialCaseFilterState,
} from "../observables/caseFilterState$";
import { CASE_FILTER_STATE } from "../types/CommonTypes";
import { getAuthValue } from "../../authModule/hooks/useAuthValue";
import { USER_ROLES } from "../../userModule/types/CommonTypes";

const getSurgeonSelfName = (): string | null => {
  const { user } = getAuthValue();
  if (user?.role !== USER_ROLES.SURGEON) return null;
  const name = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();
  return name || null;
};

const applySurgeonLock = (state: CASE_FILTER_STATE): CASE_FILTER_STATE => {
  const surgeonSelfName = getSurgeonSelfName();
  if (!surgeonSelfName) return state;
  return { ...state, attendingSurgeonNames: [surgeonSelfName] };
};

function useCaseFilterValue(): CASE_FILTER_STATE {
  return useObservableValue(caseFilterState$);
}

export function useCaseFilterCount(): number {
  return useObservableValue(caseFilterCount$);
}

export default useCaseFilterValue;

export const getCaseFilterValue = () => caseFilterState$.getValue();

export const setCaseFilterValue = (filterState: CASE_FILTER_STATE) => {
  const next = applySurgeonLock(filterState);
  caseFilterState$.next(next);
  updateCaseFilterCount(next);
};

export const updateCaseFilterValue = (
  filterState: Partial<CASE_FILTER_STATE>
) => {
  const merged = { ...caseFilterState$.getValue(), ...filterState };
  const next = applySurgeonLock(merged);
  caseFilterState$.next(next);
  updateCaseFilterCount(next);
};

export const resetCaseFilterValue = () => {
  setCaseFilterValue(initialCaseFilterState);
  caseFilterCount$.next(0);
};

export const updateCaseFilterCount = (filters: CASE_FILTER_STATE) => {
  let count = 0;
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) count++;
    if (value && typeof value === "string") count++;
  });

  if (filters.dateRange.from && filters.dateRange.to) count++;

  caseFilterCount$.next(count);
};
